import { gql } from '@/utilities/gql';
import type { VariablesOf } from '@/utilities/gql';
import { gqlClient } from '@/utilities/graphQLClient';

const QUERY = gql(`
  mutation removeWatchlistItem(
    $companyId: String!
    $watchlistId: String!
  ) {
    removeWatchlistItem(companyId: $companyId, watchlistId: $watchlistId)
  }
`);

type Args = VariablesOf<typeof QUERY>;

// TODO: This needs refactoring. We shouldn't be appending these values to the query args
// However, the legacy logic piggybacks these values in so they can used within the queryFn mutation success
type OverScopedValues = {
  includeSnackBar?: boolean;
  message?: string;
};

export const removeQueryFn = async ({
  companyId,
  watchlistId,
}: Args & OverScopedValues) => {
  try {
    const response = await gqlClient.request(QUERY, {
      companyId,
      watchlistId,
    });
    const { removeWatchlistItem, errors } = response;
    if (errors && errors.length > 0) {
      throw new Error(errors[0].message);
    }
    return removeWatchlistItem;
  } catch (error) {
    console.log(error);
  }
  return false;
};
